import React from "react";

export default function Interviews() {
  return <div>Interviews</div>;
}
